import Emittery from "emittery";
import { injectable } from "inversify";
import type { EventDataType, ListenerService } from "@whatslly/types/instant-messaging/ListenerService";
import { DOM_EVENT_TYPES } from "@whatslly/types/instant-messaging/ListenerService";
@injectable()
export class MessagingEventBus extends Emittery<EventDataType> implements ListenerService {
  constructor() {
    super();
  }

  startListenToMainChatWindowReplace() {
    setTimeout(() => this.emit(DOM_EVENT_TYPES.HAS_LOADED), 0);
  }
}
